// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7feea207","186":"3c25caa1","225":"2154304a","344":"f34039db","372":"3bd6edff","443":"1208ef9c","738":"55c02d41","841":"0672205f","856":"54e682c7"}[chunkId] + ".chunk.js";
};